import {
  TimelineAnalysisCancelResponseSchema,
  TimelineAnalysisRealtimeTokenSchema,
  TimelineAnalysisSettingsSchema,
} from '@sweetistics/contracts';
import type { z } from 'zod';

export type TimelineAnalysisSettingsResponseInput = z.input<typeof TimelineAnalysisSettingsSchema>;
export type TimelineAnalysisSettingsResponseOutput = z.output<typeof TimelineAnalysisSettingsSchema>;

export function serializeTimelineAnalysisSettingsResponse(
  payload: TimelineAnalysisSettingsResponseInput
): TimelineAnalysisSettingsResponseOutput {
  return TimelineAnalysisSettingsSchema.parse(payload);
}

export type TimelineAnalysisCancelResponseInput = z.input<typeof TimelineAnalysisCancelResponseSchema>;
export type TimelineAnalysisCancelResponseOutput = z.output<typeof TimelineAnalysisCancelResponseSchema>;

export function serializeTimelineAnalysisCancelResponse(
  payload: TimelineAnalysisCancelResponseInput
): TimelineAnalysisCancelResponseOutput {
  return TimelineAnalysisCancelResponseSchema.parse(payload);
}

export type TimelineAnalysisRealtimeTokenInput = z.input<typeof TimelineAnalysisRealtimeTokenSchema>;
export type TimelineAnalysisRealtimeTokenOutput = z.output<typeof TimelineAnalysisRealtimeTokenSchema>;

export function serializeTimelineAnalysisRealtimeToken(
  payload: TimelineAnalysisRealtimeTokenInput
): TimelineAnalysisRealtimeTokenOutput {
  return TimelineAnalysisRealtimeTokenSchema.parse(payload);
}
